import React from 'react';
import { Link } from 'react-router-dom';
import Arrow from '../Assests/Group 2 (3).png';
import CertificateCardGrid from '../Components/CertificatesCard';
// import CertificateCard from '../Components/CertificateCard';

const Certificates = () => {
  return (
    <div className='bg-[#242424] text-white font-inria mt-10 md:mt-20 mx-10 lg:mx-20'>
      <div>
        <div className="flex flex-col lg:flex-row">
          <div className="mt-20 ml-10 lg:mt-72 lg:ml-20 flex-shrink-0 lg:w-1/3 md:block lg:hidden" data-aos='fade-left'>
            <div className="w-full lg:w-96">
              <h1 className="text-4xl lg:text-6xl">My Certificates</h1>
            </div>
            <div className="mt-10 lg:mt-20">
              <Link to='/certificate' className="flex gap-4 lg:gap-10 cursor-pointer"  id='blink'>
                <img src={Arrow} alt="Arrow" className='mt-1' /> 
                <h1 className="text-2xl lg:text-4xl">View More</h1>
              </Link>
            </div>
          </div>
          <div className='mt-10 lg:mt-0 lg:ml-10 w-full lg:w-2/3'>
            <CertificateCardGrid displayCount={2} gridTemplate=" grid-cols-1 md:grid-cols-2" />
            {/* <CertificateCard/> */}
          </div>
          <div className="mt-20 ml-10 lg:mt-28 lg:ml-20 flex-shrink-0 lg:w-1/3 hidden lg:block" data-aos='fade-left'>
            <div className="w-full lg:w-96">
              <h1 className="text-4xl lg:text-6xl">My Certificates</h1>
            </div>
            <div className="mt-10 ml-10">
              <Link to='/certificate' className="flex gap-4 lg:gap-10 cursor-pointer"  id='blink'>
                <img src={Arrow} alt="Arrow" className='mt-1' /> 
                <h1 className="text-2xl lg:text-4xl">View More</h1>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificates;